"use client";

import { Section } from "@/components/core";
import { WalletAddress } from "@/components/core/WalletAddress/WalletAddress";
// import {
//   Alert,
//   AlertClose,
//   AlertContent,
//   AlertDescription,
//   AlertIcon,
//   AlertTitle,
// } from "@/components/ui/alert";
import { useAuth } from "@/context/auth";
// import { useTranslations } from "next-intl";
// import { InfoCircle } from "iconsax-reactjs";
// import { useReadContract } from "wagmi";
import { useEffectiveAddress } from "@/hooks/auth/useEffectiveAddress";
// import { WrapperABI } from "@/contract/abi/wrapper";
// import ContractAddress from "@/contract/addresses";

export const UserInfo = () => {
  const { user } = useAuth();
  const address = useEffectiveAddress();

  // const t = useTranslations("profile");
  // const wrapperBalance = useReadContract({
  //   address: ContractAddress.WRAPPER,
  //   functionName: "balanceOf",
  //   abi: WrapperABI,
  //   args: [address as `0x${string}`],
  // });

  return (
    <Section className="mt-0 pt-0 md:pt-6">
      <div className="md:space-y-2">
        <WalletAddress address={address} truncateSize="lg" responsive={false} />
        {typeof user?.nickname === "string" && (
          <p className="md:text-lg md:font-medium">{user?.nickname}</p>
        )}
      </div>
      {/* {wrapperBalance.data === BigInt(0) ? (
        <div className="w-full flex items-center justify-center md:mt-6">
          <Alert className="md:max-w-2xl">
            <AlertClose />
            <AlertIcon>
              <InfoCircle variant="Bold" />
            </AlertIcon>
            <AlertContent>
              <AlertTitle>{t("sellerProfile.title")}</AlertTitle>
              <AlertDescription>
                {t("sellerProfile.peerRequired")}
              </AlertDescription>
            </AlertContent>
            <ConvertDialog />
          </Alert>
        </div>
      ) : null} */}
    </Section>
  );
};
